import { Link } from "react-router-dom";

export type AnchorWrapperProps = {
    href?: string;
    target?: string;
    children: React.ReactNode;
}

/// Uses React Router <Link> tag for local links and an <a> tag for external links.
/// Allows template developers to use the familiar <a> tag for all links, with local links benefiting from SPA routing (no page reload).
export function AnchorWrapper(props: AnchorWrapperProps) {
    const { href, target, children, ...rest } = props;

    // Use cases not supported by <Link< component...
    if (target || !href)
        return <a href={href} target={target} {...rest}>{children}</a>;

    // If the href is relative, we have to use a <Link> tag...
    const to = href.startsWith("/") ? href :
        href.startsWith(document.location.origin) ? href.substring(document.location.origin.length) :
        undefined;

    // If the href does not fit any of the <Link> use cases, fall back to a raw anchor tag...
    return to ?
        <Link to={to} {...rest}>{children}</Link> :
        <a href={href} target={target} {...rest}>{children}</a>;
};